import SVGIconWrapper from "./SVGIconWrapper"

const IconCaretUp = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 500"
        iconClass={`icon--caret-up ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M500 359.4c0 8.5-3.1 15.8-9.3 22s-13.5 9.3-22 9.3H31.2c-8.5 0-15.8-3.1-22-9.3S0 367.8 0 359.4s3.1-15.8 9.3-22L228 118.7c6.2-6.2 13.5-9.3 22-9.3s15.8 3.1 22 9.3l218.8 218.8c6.1 6.1 9.2 13.4 9.2 21.9z" />
    </SVGIconWrapper>
)

export default IconCaretUp